import React, { useState } from "react";
import "./ComboListComponent.css";
import leftArrow from "../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import emotions7 from "../../assests/emotions7.svg";
import LoadingSpinner from "../Loading/component";

const ComboListComponent = (props) => {
  const navigate = useNavigate();
  const [showFilters, setShowFilters] = useState(false);

  const handleClick = () => navigate("/");
  const newComboCreation = () => navigate("/home/comboCreation");
  const handleComboDetails = (comboId) => navigate(`/home/combodetails/${comboId}`);
  
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="combo-list-container">
          <div className="combo-list-header">
            <div className="combo-list-header-left">
              <img
                onClick={handleClick}
                className="combo-list-back-icon"
                src={leftArrow}
                alt="Back"
              />
              <h2 className="combo-list-title">Combo</h2>
            </div>
            <input
              type="text"
              placeholder="Search combo by ID/Name"
              value={props.searchTerm || ""}
              onChange={(e) => {
                const value = e.target.value || "";
                props.setSearchTerm(value);
                props.SearchCombosApi(value);
              }}
              className="combo-list-search-input"
            />
            <button className="combo-list-create-button" onClick={newComboCreation}>
              Create Combo
            </button>
          </div>

          <div className="combo-list-content">
            {/* Hamburger Menu */}
            <div 
              className={`combo-list-hamburger ${showFilters ? 'active' : ''}`}
              onClick={toggleFilters}
            >
              <div className="combo-list-hamburger-line"></div>
              <div className="combo-list-hamburger-line"></div>
              <div className="combo-list-hamburger-line"></div>
            </div>
            
            {/* Overlay for mobile */}
            <div 
              className={`combo-list-overlay ${showFilters ? 'active' : ''}`}
              onClick={toggleFilters}
            ></div>
            
            {/* Filters Section */}
            <div className={`combo-list-filters ${showFilters ? 'active' : ''}`}>
              <button
                onClick={() => {
                  props.handleClearAllFilter();
                  if (window.innerWidth <= 768) {
                    setShowFilters(false);
                  }
                }}
                className="combo-list-clear-button"
              >
                Clear All
              </button>
              <div className="combo-list-filter-section">
                <h4 className="combo-list-filter-title">Status</h4>
                <div className="combo-list-filter-option">
                  <input
                    className="combo-list-checkbox"
                    type="checkbox"
                    name="status"
                    value="Active"
                    checked={props.comboStatusFilter.includes("Active")}
                    onChange={() => props.toggleComboStatusFilter("Active")}
                  />
                  <span className="combo-list-status-active">Active</span>
                </div>
                <div className="combo-list-filter-option">
                  <input
                    className="combo-list-checkbox"
                    type="checkbox"
                    name="status"
                    value="Inactive"
                    checked={props.comboStatusFilter.includes("Inactive")}
                    onChange={() => props.toggleComboStatusFilter("Inactive")}
                  />
                  <span className="combo-list-status-inactive">Inactive</span>
                </div>
              </div>

              <div className="combo-list-filter-section">
                <h4 className="combo-list-filter-title">Sort By</h4>
                <div className="combo-list-filter-option">
                  <input
                    className="combo-list-checkbox"
                    type="checkbox"
                    name="sort"
                    value="priceHighToLow"
                    checked={props.sortOption === "priceHighToLow"}
                    onChange={() =>
                      props.setSortOption(
                        props.sortOption === "priceHighToLow" ? "" : "priceHighToLow"
                      )
                    }
                  />
                  <span>Price (high to low)</span>
                </div>
                <div className="combo-list-filter-option">
                  <input
                    className="combo-list-checkbox"
                    type="checkbox"
                    name="sort"
                    value="priceLowToHigh"
                    checked={props.sortOption === "priceLowToHigh"}
                    onChange={() =>
                      props.setSortOption(
                        props.sortOption === "priceLowToHigh" ? "" : "priceLowToHigh"
                      )
                    }
                  />
                  <span>Price (low to high)</span>
                </div>
                <div className="combo-list-filter-option">
                  <input
                    className="combo-list-checkbox"
                    type="checkbox"
                    name="sort"
                    value="aToZ"
                    checked={props.sortOption === "aToZ"}
                    onChange={() =>
                      props.setSortOption(props.sortOption === "aToZ" ? "" : "aToZ")
                    }
                  />
                  <span>A to Z</span>
                </div>
                <div className="combo-list-filter-option">
                  <input
                    className="combo-list-checkbox"
                    type="checkbox"
                    name="sort"
                    value="zToA"
                    checked={props.sortOption === "zToA"}
                    onChange={() =>
                      props.setSortOption(props.sortOption === "zToA" ? "" : "zToA")
                    }
                  />
                  <span>Z to A</span>
                </div>
              </div>
            </div>

            <div className="combo-list-grid-container">
              {props.combos.length > 0 ? (
                <div className="combo-list-grid">
                  {props.combos.map((combo) => (
                    <div
                      key={combo.id}
                      className={`combo-list-card ${
                        !combo.isActive ? "combo-list-card-disabled" : ""
                      }`}
                      onClick={() => {
                        handleComboDetails(combo.id);
                        if (window.innerWidth <= 768) {
                          setShowFilters(false);
                        }
                      }}
                    >
                      <div className="combo-list-card-image-container">
                        {combo.image_url && combo.image_url.length > 0 && (
                          <img
                            alt="Combo"
                            src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${combo.image_url}`}
                            className="combo-list-card-image"
                          />
                        )}
                      </div>
                      <h4 className="combo-list-card-title">{combo.name}</h4>
                      <p className="combo-list-card-description">{combo.description}</p>
                      <div className="combo-list-card-price-container">
                        <div className="combo-list-card-prices">
                          <p className="combo-list-card-actual-price">₹{combo.actual_price}</p>
                          <p className="combo-list-card-total-price">₹{combo.total_price}</p>
                        </div>
                        <p className="combo-list-card-id">ID: {combo.id}</p>
                      </div>
                      <p className="combo-list-card-expiry">
                        Expiry Date:{" "}
                        {moment
                          .utc(combo.expires_at)
                          .tz("Asia/Kolkata")
                          .format("YYYY-MM-DD")}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="combo-list-empty-state">
                  <div className="combo-list-empty-image-container">
                    <img src={emotions7} alt="No combos found" />
                    <p className="combo-list-empty-message">No combos found</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ComboListComponent;